import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import ReferenceService from "@/common/reference.service";
import { API_URL, POSTCODE_API_URL } from "@/common/config";
import store from '@/store/store';
import { LOADING_START, LOADING_END } from '@/store/mutations.type';

const ApiService = {
    init() {
      Vue.use(VueAxios, axios);
      Vue.axios.defaults.baseURL = API_URL;
  
      axios.interceptors.request.use(function (config) {
        // console.log('loading...');
        store.commit(LOADING_START);
        return config;
      }, function(error) {
        store.commit(LOADING_END);
        return Promise.reject(error);
      })
  
      axios.interceptors.response.use(function (config) {
        // console.log('loading Finished!');
        store.commit(LOADING_END);
        return config;
      }, function(error) {
        // Vue.swal({
        //   type: 'error',
        //   title: 'Oops...',
        //   text: error.response != undefined && error.response.data != null ? error.response.data.message : "There was a problem, please try again."
        // })
        store.commit(LOADING_END);
        return Promise.reject(error);
      })
    },
  
    setHeader() {
      Vue.axios.defaults.headers.common["Reference"] = `${ReferenceService.getToken()}`;
    },

    query(resource, params) {
      return Vue.axios.get(resource, params).catch(error => {
        throw new Error(`[RWV] ApiService ${error}`);
      });
    },
  
    get(resource, slug = "") {
      return Vue.axios.get(`${resource}/${slug}`).catch(error => {
        throw new Error(`[RWV] ApiService ${error}`);
      });
    },
  
    post(resource, params) {
      return Vue.axios.post(`${resource}`, params);
    },
  
    update(resource, slug, params) {
      return Vue.axios.put(`${resource}/${slug}`, params);
    },
  
    put(resource, params) {
      return Vue.axios.put(`${resource}`, params);
    },
  
    delete(resource) {
      return Vue.axios.delete(resource).catch(error => {
        throw new Error(`[RWV] ApiService ${error}`);
      });
    }
  };

  export default ApiService;

  export const SettingService = {
      get(payload) {
        // Get settings for quote without saving an entry in WidgetQuotes
        return ApiService.get(`getsettings/${payload}`);
      },
      startQuote(payload) {
        // When the user starts a quote - create a quote instance
        return ApiService.post('/CreateQuoteInstance', payload);
      },
      completeQuote() {
        return ApiService.post('CompleteQuote');
      }
  }

  export const CustomerService = {
    SaveCustomer(payload) {
      return ApiService.post('SubmitCustomerDetails', payload);
    }
  }

  export const PostcodeService = {
    get(payload) {
      return axios.get(`${POSTCODE_API_URL}?postcode=${payload}`);
    }
  }

  export const ProductService = {
      
      postAnswers(payload) {
        // var payload = {
        //     "CompanyId": 11,
        //     "SettingId": 1,
        //     "QuoteReference": "25A503DA-27C1-491F-9FBB-06E7406E6AC2",
        //     "PropertyType": "House1",
        //     "Bathrooms": 1,
        //     "Bedrooms": 1,
        //     "FuelType": 1,
        //     "WaterCylinder": "remove",
        //     "BoilerType": 1,
        //     "MoveBoilerPosition": true,
        //     "BoilerLocation": "Kitchen",
        //     "FlueExit": "Wall"
        // }

        return ApiService.post('GetProducts', payload);
      }
  }